// Real skill slugs mirrored from lib/hermes/agents.ts (SEED). That file is
// server-only (reads SARAA_DATA_DIR at runtime) so its data is copied here as
// a plain, client-safe array for the public landing page's skill marketplace.

export interface HermesSkillCategory {
  id: string;
  skills: string[];
}

export const HERMES_SKILL_CATEGORIES: HermesSkillCategory[] = [
  {
    id: "marketing",
    skills: [
      "ai-global-brand-content", "ai-global-reel-workflow", "aiglobal-success-story-carousel",
      "architecture-diagram", "ascii-art", "ascii-video", "baoyu-comic", "baoyu-infographic",
      "brand-book-creator", "claude-design", "comfyui", "design-md", "excalidraw", "humanizer",
      "hyperframes", "ideation", "ireeduimed-brand-content", "kie-image-to-image", "manim-video",
      "p5js", "pannellum-3d-tour", "pixel-art", "popular-web-designs", "pretext",
      "property-video-slideshow", "sketch", "songwriting-and-ai-music", "supersplat-real-estate-3d-tour",
      "touchdesigner-mcp", "mongolian-real-estate-content", "news-poster", "social-media-automation",
      "xurl", "gif-search", "heartmula", "kie-content-maker", "songsee", "spotify", "youtube-content",
    ],
  },
  {
    id: "business",
    skills: [
      "airtable", "business-sales-coaching", "gmail-call-transcriber", "google-workspace",
      "lead-nurture-newsletter", "linear", "maps", "nano-pdf", "notion", "ocr-and-documents",
      "odoo19-query", "personal-expense-tracking", "powerpoint", "teams-meeting-pipeline",
      "zangia-lead-generation", "content-strategist", "enterprise-ai-agent-transformation",
      "sell-it-like-serhant-coach", "us-government-contracting", "crm-system-integration",
      "himalaya", "obsidian",
    ],
  },
  {
    id: "dev",
    skills: [
      "debugging-hermes-tui-commands", "hermes-agent-skill-authoring", "node-inspect-debugger",
      "plan", "python-debugpy", "requesting-code-review", "simplify-code", "spike",
      "subagent-driven-development", "systematic-debugging", "test-driven-development", "writing-plans",
      "codebase-inspection", "github-auth", "github-code-review", "github-issues", "github-pr-workflow",
      "github-repo-management", "claude-code", "codex", "hermes-agent", "opencode", "native-mcp",
      "godmode", "web-security-reconnaissance",
    ],
  },
  {
    id: "ai",
    skills: [
      "audiocraft-audio-generation", "dspy", "evaluating-llms-harness", "huggingface-hub",
      "llama-cpp", "obliteratus", "segment-anything-model", "serving-llms-vllm", "weights-and-biases",
      "jupyter-live-kernel", "mongolian-real-estate-leads", "arxiv", "blogwatcher", "llm-wiki",
      "mongolian-business-law", "polymarket", "research-paper-writing", "rss-news-pipeline",
    ],
  },
  {
    id: "ops",
    skills: [
      "agent-ops-dashboards", "kanban-orchestrator", "kanban-worker", "remote-hermes-debugging",
      "webhook-subscriptions", "openhue", "minecraft-modpack-server", "pokemon-player", "dogfood",
      "hermes-visual-agent-system", "yuanbao",
    ],
  },
];

const ACRONYMS: Record<string, string> = {
  ai: "AI", aiglobal: "AI Global", crm: "CRM", pr: "PR", llm: "LLM", llms: "LLMs",
  pdf: "PDF", ocr: "OCR", mcp: "MCP", tui: "TUI", api: "API", seo: "SEO", ui: "UI",
  gif: "GIF", rss: "RSS", github: "GitHub", dspy: "DSPy", p5js: "p5.js", vllm: "vLLM",
  "3d": "3D", us: "US",
};

export function formatSkillLabel(slug: string): string {
  return slug
    .split("-")
    .map((word) => ACRONYMS[word.toLowerCase()] ?? word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
